import _ from 'underscore';

import { AppState } from '~src/app/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { publishedConnectionTableExtractsRefreshNow } from '~src/publishedConnectionTable/actions/PublishedConnectionTableExtractsRefreshNowAction';
import { IPublishedConnectionTable } from '~src/publishedConnectionTable/serverApi/types/IPublishedConnectionTable';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { currentUserIsOwnerOrAdmin, hasRunNowPermission } from '~src/spacesPlatform/utils/MixedContentHelpers';
import { IRefreshExtractAction } from '~src/ts/ServerApi/types/actionNames';

function allItemsPublishedConnectionTable(targetItems: IContentInfo[]): boolean {
  return targetItems.length >= 1 && _.all(targetItems, (item => item.contentType === 'virtualConnectionTable'));
}

function allItemsFromSamePublishedConnection(targetItems: IContentInfo[]): boolean {
  if (targetItems.length >= 1) {
    const publishedConnectionId = (targetItems[0] as unknown as IPublishedConnectionTable).publishedConnectionId;
    return _.all(targetItems, (item => (item as unknown as IPublishedConnectionTable).publishedConnectionId === publishedConnectionId));
  }
  return false;
}

function canRunNow(state: AppState, targetItems: IContentInfo[]): boolean {
  return targetItems.length >= 1 && currentUserIsOwnerOrAdmin(state, targetItems[0]) && hasRunNowPermission(state);
}

export const PublishedConnectionTableExtractsRefreshNowAction: IEntityAction<IContentInfo<'virtualConnectionTable'>, IRefreshExtractAction> = {
  name: EntityActionNames.PublishedConnectionTableExtractsRefreshNow,
  translateName: Messages.publishedConnectionTableExtractsRefreshNow_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return allItemsPublishedConnectionTable(targetItems);
  },
  isClickable: (availableActions: IRefreshExtractAction, targetItems: IContentInfo[], state: AppState) => {
    return !!(availableActions && availableActions.refreshExtract) && allItemsFromSamePublishedConnection(targetItems)
      && canRunNow(state, targetItems);
  },
  createReduxAction: (targetItems: IContentInfo[]) => publishedConnectionTableExtractsRefreshNow(targetItems)
};
